var Scroller = ({
  selector = '[data-scroll-el]',
  scrollBehavior = 'auto',
}) => {
  var clickHandler = (event) => {
    event.preventDefault();
    var { currentTarget } = event;
    var el = document.getElementById(currentTarget.dataset.target);

    if (el) {
      el.scrollIntoView({ behavior: scrollBehavior });
    }
  };

  var els = document.querySelectorAll(selector);

  for (let i = 0; i < els.length; i += 1) {
    var el = els[i];

    el.addEventListener('click', clickHandler);
  }
};

export default Scroller;
